import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import { mapState } from 'vuex';
import listMixin from '@/components/niotaClassic/listMixin';
import overviewEditMixin from '@/components/core/dtwin/overviewEditMixin';
import listOptionsPersistenceMixin from '@/components/custom/listOptionsPersistenceMixin';
import iconsMixin from '@/components/core/dtwin/state/bridge/iconsMixin';
import { userItemsPerListMixin } from '@/utils/vuex';
import ApiService from '@/services/apiService';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'IsHeatMonitoringMeterPointList',
  mixins: [listMixin, listOptionsPersistenceMixin, iconsMixin, userItemsPerListMixin, overviewEditMixin],
  props: {
    favouriteFilterEnabled: {
      type: Boolean,
      required: true
    },
    accounts: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    searchTypes: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    }
  },
  data: function data() {
    return {
      meterObject: null,
      disableFetchOnCreatedMixin: true,
      lastSearch: null,
      searchItems: [],
      listPersistencePath: 'IsHeatMonitoring.listMeterPoints',
      searchMode: 'multi',
      favouriteMode: 'on',
      showDialogCreate: false,
      isFetching: false,
      tableOptions: _objectSpread({}, defaultTableOptions),
      defaultTableOptions: _objectSpread({}, defaultTableOptions),
      selected: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'language'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    headerBG: function headerBG() {
      return './img/consumer.png';
    },
    shownColumns: function shownColumns() {
      var m = {};
      this.tableHeaders.forEach(function (e) {
        return m[e.value] = true;
      });
      return m;
    },
    selectedRows: function selectedRows() {
      return this.list.filter(function (item) {
        return item.selected;
      });
    },
    tableHeaders: function tableHeaders() {
      var _this = this;

      return [{
        sortable: false,
        value: 'icon',
        hide: 'mdAndDown'
      }, {
        text: this.$i18n_t('Common.id'),
        value: 'id'
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.deviceAccount'),
        value: this.showAccountCol ? 'tenant' : null,
        sortable: true
      }, {
        text: this.$i18n_t('IS.HeatMonitoring.customerId'),
        value: 'customerId',
        sortable: true
      }, {
        text: this.$i18n_t('IS.HeatMonitoring.meterId'),
        value: 'meterId',
        sortable: true
      }, {
        value: 'lastReading',
        sortable: true
      }, {
        value: 'consumption',
        sortable: true
      }, {
        value: 'consumption_24h',
        sortable: true
      }, {
        value: 'consumption_month',
        sortable: true
      }, {
        value: 'consumption_year',
        sortable: true
      }, {
        text: '',
        value: 'actions',
        sortable: false,
        width: '80'
      }].filter(function (item) {
        return item.value && (!item.hide || !_this.$vuetify.breakpoint[item.hide]);
      });
    },
    tableFooterProps: function tableFooterProps() {
      return {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
      };
    },
    operationalStatus: function operationalStatus() {
      return {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      };
    },
    canDeleteDevice: function canDeleteDevice() {
      return this.twinDependencies && (get(this.twinDependencies, 'aggregatedStates') || []).length === 0;
    },
    showAccountCol: function showAccountCol() {
      return this.permissions['IsHeatMonitoring.manage'] || this.permissions['all.manage'];
    }
  }),
  watch: {
    favouriteFilterEnabled: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.fetchList(true);
    }, 500),
    accounts: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.fetchList(true);
    }, 500)
  },
  created: function created() {
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  methods: {
    get: get,
    showDeletePrompt: function showDeletePrompt(item) {
      this.meterObject = item;
      this.twinDeletePrompt = true;
      this.fetchTwinDependencies(this.meterObject);
    },
    setSelected: function setSelected(rows) {
      this.$emit('update-selected-rows', rows);
    },
    initializedDefaultPageFilters: function initializedDefaultPageFilters() {
      this.$emit('loaded-favourite-filter', this.favouriteFilter || false);
      this.fetchList();
    },
    relativeTime: function relativeTime(date) {
      if (date) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(date).fromNow();
      }

      return '-';
    },
    fetchList: function fetchList() {
      var _this2 = this;

      var fromStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      var searchItems = this.searchItems.map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });

      if (!isEqual(this.lastSearch, JSON.stringify(searchItems))) {
        this.lastSearch = JSON.stringify(searchItems);
        this.tableOptions = _objectSpread(_objectSpread({}, this.tableOptions), {}, {
          page: 1
        });
      }

      var tableOptions = fromStart ? _objectSpread(_objectSpread({}, this.tableOptions), {}, {
        page: 1
      }) : this.tableOptions;
      var sortBy = tableOptions.sortBy,
          sortDesc = tableOptions.sortDesc,
          page = tableOptions.page,
          itemsPerPage = tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'id';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : false;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC'; // persist options for next call of this page (during this browser-tab-session)

      this.$store.state.app.pageFilters = _objectSpread(_objectSpread({}, this.$store.state.app.pageFilters), {}, {
        IsHeatMonitoring: _objectSpread(_objectSpread({}, get(this.$store.state.app, 'pageFilters.IsHeatMonitoring') || {}), {}, {
          listMeterPoints: {
            searchDetails: this.searchItems,
            tableOptions: tableOptions,
            favouriteFilter: this.favouriteFilterEnabled || false
          }
        })
      });
      var usedPage = page ? page - 1 : 0;
      var usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      var filters = [{
        type: 'tenantIds',
        ids: this.accounts.map(function (acc) {
          return acc.id;
        })
      }];
      ApiService.isHeatMonitoringFetch(this, // context
      'meterpoints', usedPage * usedItemsPerPage, // offset
      usedItemsPerPage, // limit
      searchItems, filters, {
        variable: sortItem,
        direction: sortDirection
      }, // orderBy
      this.favouriteFilterEnabled ? ['favourites'] : null).then(function (result) {
        _this2.list = result.meterpoints;
        _this2.serverItemsLength = result.totalCount;
      }).catch(function (error) {
        console.error('Error fetching virtual devices', error);
      }).finally(function () {
        _this2.isFetching = false;
      });
    },
    searchUpdated: function searchUpdated(search) {
      this.searchItems = search;
      this.fetchList(true);
      this.$emit('search-updated', this.searchItems);
    },
    deleteMeterPoint: function deleteMeterPoint(selected) {
      var _this3 = this;

      ApiService.digitalTwinDelete(selected.id).then(function () {
        _this3.twinDeletePrompt = false;

        _this3.$snack(_this3.$i18n_t('DigitalTwin.VirtualDevice.snacks.deleteSuccess', 'success'));

        _this3.fetchList();
      }).catch(function (error) {
        console.error(error);
        var errorTranslateKey = "Error.".concat(get(error, 'response.data.message'));

        if (error.response && _this3.$i18n_t(errorTranslateKey) !== errorTranslateKey) {
          _this3.$snack(_this3.$i18n_t(errorTranslateKey), 'error');
        } else {
          _this3.$snack(_this3.$i18n_t('DigitalTwin.VirtualDevice.snacks.deleteFailed'), 'error');
        }
      });
    }
  }
};